<template>
  <div>
    <section
      class="h-80 d-flex align-center flex-column justify-center mb-2">
        <img id="logo" class="mb-4"
          alt="logo"
          :src="require(`@/assets/jindocoin-icon.svg`)"/>
        <h1 class="hero-title text-center display-1 font-weight-black">
          Hello 👋 from <br> Jindo coin 🐕
        </h1>
        <span class="grey--text">A small meme to the moon. ($JINDO)</span>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
  .hero-title {
    padding: 0.5rem 2em 0.5em;
    background: url(@/assets/media/bg.svg) no-repeat;
    background-position: center center;
    background-size: contain;
  }
  #logo {
    width: 100%;
    max-width: 220px;
  }
</style>
